<ul class="tree-view">
    <li class="system-main" 
       *ngFor="let item of items" >
      <div class="system-main__apps" (click)="onexpand(item,before);emit({data:item,path:parent+'>'+item.columnName});emitPath(parent+'>'+item.columnName)"  (mouseover)="item.showClose=true" (mouseout)="item.showClose=false" *ngIf="item.isvisible">
          <span class="system-main__icon"><i [ngClass]="(!item.isopen) ? 'fa fa-plus': 'fa fa-minus'"></i></span>
          <span class="system-main__name"> {{ item.columnName }}</span>
          <span class="system-main__close" [hidden]="!item.showClose" ><i class='fa fa-close' (click)="clear(item,$event)" ></i></span>    
      </div>
      <ng-container *ngTemplateOutlet="detail;context:{item:item,path:parent+'>'+item.columnName}" ></ng-container>
      <ul *ngIf="item.child && item.isopen && item.isvisible" >
        <custom-tree-view  [items]="item.child" [before]="item" [parent]="parent+'>'+item.columnName"  (path)="emitPath($event)" (selected)="emit($event)" [detail]="detail">
        </custom-tree-view>
      </ul>
    </li>
  </ul> 
  